import { z } from "zod";
import { MetaSchema } from "./shared";

export const NotificationFileSchema = z
  .object({ url: z.string().url() })
  .passthrough();

export const NotificationSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  message: z.string(),
  link: z.string().nullable(),
  platform: z.string(),
  createdAt: z.string().datetime(),
  files: z.array(NotificationFileSchema),
});

export const UserNotificationSchema = z.object({
  id: z.string().uuid(),
  isRead: z.boolean(),
  receivedAt: z.string().datetime(),
  notification: NotificationSchema,
});

export const NotificationsDataSchema = z.array(UserNotificationSchema);

const NotificationsResponse = z.object({
  data: NotificationsDataSchema,
  meta: MetaSchema.default,
});

export type NotificationsResponseType = z.infer<typeof UserNotificationSchema>;

export default NotificationsResponse;
